import React, { createContext, useContext } from 'react';
var AuthContext = /*#__PURE__*/createContext([undefined, function () {}]);
export var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: value
  }, children);
};
export var useAuthProvider = function useAuthProvider() {
  return useContext(AuthContext);
};